import type { CSSProperties } from 'react';
import { mensajeDeError } from '@lib/mensaje-error';

/**
 * Mensaje de error debajo de la acción que falló. Se pasa el `error` de la
 * mutación tal cual: si es `null` no dibuja nada, así se puede dejar siempre
 * puesto sin condicionar.
 *
 * Es `role="alert"` para que un lector de pantalla lo anuncie al aparecer.
 */
export function ErrorInline({
  error,
  fallback,
  style,
}: {
  error: unknown;
  /** Qué no se pudo hacer, en palabras del usuario. */
  fallback: string;
  style?: CSSProperties;
}) {
  if (!error) return null;
  return (
    <p className="status status-error" role="alert" style={{ display: 'block', ...style }}>
      {mensajeDeError(error, fallback)}
    </p>
  );
}
